module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eInvoice"
  }, [_c('banner', {
    attrs: {
      "clazz": "eInvoice-banner",
      "url": "eInvoice"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goRegister(1)
      }
    }
  }, [_vm._v("申请体验")])], 1)], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "eInvoice-list2"
  }, [_c('div', {
    staticClass: "item-list"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-tab"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card",
      "stretch": ""
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "电子发票"
    }
  }, [_c('div', {
    staticClass: "rel clearfix content"
  }, [_c('div', {
    staticClass: "fl left-list"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("精确定位，加速发票处理")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('div', {
    staticClass: "left-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/img1.png"),
      "alt": "精确定位，加速发票处理"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/peitu-1.png"),
      "alt": "精确定位，加速发票处理"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg01"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "发票OCR"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl left-list"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("增值税发票识别+验真")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  扫描并对供应商提供的纸质文档分析和处理，获取发票代码、发票号码、开票日期、 开票金额、纳税人编号等字段，并将识别的数据信息，传到公司的数据系统或业务流程系统。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/peitu-2.png"),
      "alt": "增值税发票识别+验真"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg02"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "自动对账"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl left-list"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("提高处理效率，规避人为错误")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  自动执行发票对账流程，以消除错误，降低风险并减轻应付账款团队负担，实现更好的战略洞察。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/peitu-3.png"),
      "alt": "提高处理效率，规避人为错误"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg03"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "重开发票"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl left-list"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("透明且更接近现实成本")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  根据所消耗的服务，每个月或每年结束每个业务部门的发票。因此，所有投资和运营成本都与公司的业务直接相关并且具有价值。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "left-link"
  }, [_c('div', {
    staticClass: "left-link-item"
  }, [_c('span'), _vm._v("\n                    根据公认的成本重新开票\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "left-link-item"
  }, [_c('span'), _vm._v("\n                    关闭发票的重新开票（可能在申请时进入）\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "left-link-item"
  }, [_c('span'), _vm._v("\n                    在内部时间表（内部CRA）上重新开票\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/peitu-4.png"),
      "alt": "在内部时间表（内部CRA）上重新开票"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg04"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "AP自动化"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl left-list"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("实时效率")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  通过与ERP和其他会计系统的无缝集成，AP Automation在采购过程中生成应计和A /\n                  P条目。这种实时报告可以节省大量时间，并确保发票付款对帐流程的准确性。应计，预付费用，负债和发票条目的条目/工作流程的自动设置可减少错误并增强协作。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/peitu-5.png"),
      "alt": "通过与ERP和其他会计系统的无缝集成"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg05"
  })])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-list2"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eInvoice-list1"
  }, [_c('div', {
    staticClass: "tc container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("为什么越来越多的企业，使用电子发票？")]), _vm._v(" "), _c('div', {
    staticClass: "dib border-bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "eInvoice-list1-desc"
  }, [_vm._v("纸质发票邮寄和重开是一个手动繁重的过程，成本高，效率低，错误和延迟很普遍，导致付款延迟，电子发票可以迅速解决这些问题。")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix eInvoice-item"
  }, [_c('div', {
    staticClass: "fl item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/icon01.png"),
      "alt": "自动化您的发票流程"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "item-title"
  }, [_vm._v("自动化您的发票流程")]), _vm._v(" "), _c('p', {
    staticClass: "item-desc"
  }, [_vm._v("摆脱纸质发票邮寄，人为错误造成的重开，实现未付款项的可见性，减轻财务团队的负担")])]), _vm._v(" "), _c('div', {
    staticClass: "fl item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/icon02.png"),
      "alt": "便于全球业务开展"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "item-title"
  }, [_vm._v("便于全球业务开展")]), _vm._v(" "), _c('p', {
    staticClass: "item-desc"
  }, [_vm._v("\n            电子发票可广泛应用于本地和全球，内置增值税/税务发票识别+验证解决方案，便于业务全球开展\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "fl item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eInvoice/icon03.png"),
      "alt": "增加您的营运资金"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "item-title"
  }, [_vm._v("增加您的营运资金")]), _vm._v(" "), _c('p', {
    staticClass: "item-desc"
  }, [_vm._v("\n            通过减少发票处理时间，获得提前付款折扣，优化公司运营现金流。\n          ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc"
  }, [_c('h1', {
    staticClass: "item-list-title"
  }, [_vm._v("我们的电子发票将变革您的发票管理")]), _vm._v(" "), _c('div', {
    staticClass: "dib tl border-bottom"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-878ff2a4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/eInvoice.vue
// module id = 517
// module chunks = 12